import { TEAM_PATH } from '@/features/team/team-tabs';

import { anchor } from './setting-anchors.types';

import type { SettingAnchor } from './setting-anchors.types';

/**
 * The `/team` anchors — one per tab, the same shape `/connections` takes and for
 * the same reason: each tab answers a different question ("who is here", "what
 * may each role do", "who has been asked"), so indexing the page alone would
 * answer all three with "Team & roles".
 *
 * Indexing these is what made the tabs addressable at all. They were an
 * uncontrolled `<Tabs defaultValue>` reading nothing from the URL, so a jump to
 * the invites tab was not expressible — see `features/team/team-tabs.ts`.
 *
 * `members:view` throughout: the read that decides whether the roster renders.
 * The role and invite CONTROLS need more, and they render disabled with a
 * permission hint rather than vanishing, so a viewer landing here sees the thing
 * they searched for.
 */
export const TEAM_SETTING_ANCHORS = {
  'team-members': anchor('setting-team-members', TEAM_PATH, 'team.tab.members', 'members', 'view', {
    keywordsKey: 'settingSearch.teamMembers',
    pane: 'members',
  }),
  'team-roles': anchor('setting-team-roles', TEAM_PATH, 'team.tab.roles', 'members', 'view', {
    keywordsKey: 'settingSearch.teamRoles',
    pane: 'roles',
  }),
  'team-invitations': anchor(
    'setting-team-invitations',
    TEAM_PATH,
    'team.tab.invitations',
    'members',
    'view',
    { keywordsKey: 'settingSearch.teamInvitations', pane: 'invitations' },
  ),
} as const satisfies Record<string, SettingAnchor>;
